<div *ngIf="genericManufacturer.simulations.length > 0">
  <div class="generic-simulation-card">
    <div class="content">
      <table>
        <thead>
          <tr>
            <th>
              <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipAssiette" [matTooltipPosition]="TooltipPosition.RIGHT">
                Assiette
              </span>
            </th>
            <th>
              <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipQuantite" [matTooltipPosition]="TooltipPosition.RIGHT">
                Quantité
              </span>
            </th>
            <th>
              <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipMontantBrutHT"
                [matTooltipPosition]="TooltipPosition.RIGHT">
                Montant brut HT
              </span>
            </th>
            <th>
              <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipRSFEuro" [matTooltipPosition]="TooltipPosition.RIGHT">
                RSF&nbsp;€
              </span>
            </th>
            <th>
              <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipRSFPercent" [matTooltipPosition]="TooltipPosition.RIGHT">
                RSF&nbsp;%
              </span>
            </th>
            <th>
              <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipMontantNetHT" [matTooltipPosition]="TooltipPosition.RIGHT">
                Montant net HT
              </span>
            </th>
            <th>
              <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipSimulationIndividuelle"
                [matTooltipPosition]="TooltipPosition.RIGHT">
                Simulation individuelle (%&nbsp;brut)
              </span>
            </th>
            <th>
              <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipTotalSimulation"
                [matTooltipPosition]="TooltipPosition.RIGHT">
                Total Simulation&nbsp;€
              </span>
            </th>
            <th>
              <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipSimulationRecevoir"
                [matTooltipPosition]="TooltipPosition.RIGHT">
                Simulation à recevoir
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (base of sortedSimulations; track $index) {
          <tr>
            <td>
              <span [matTooltip]="base.descriptionAssiette || ''" [matTooltipPosition]="TooltipPosition.RIGHT">{{
                base.base }}</span>
            </td>
            <td>{{ base.quantity | customNumberFormat }}</td>
            <td>{{ base.grossAmountExclTax | customNumberFormat }}</td>
            <td>{{ base.discountEuroExclTax | customNumberFormat }}</td>
            <td>{{ base.discountPercent | customNumberFormat }}</td>
            <td>{{ getBaseNetAmountExclTax(base) | customNumberFormat }}</td>
            <td>
              <input #inputPercentileTarget type="text" name="targetPercentage" [value]="(base.grossPercentileTarget | customNumberFormat)
                " (keyup.enter)="inputPercentileTarget.blur(); focusNextInput($event)"
                
              (input)="onTargetPercentageChange(base, $event)" (blur)="onTargetPercentageBlur(base, $event)" (focus)="
                  inputPercentileTarget.value === '-' ? (inputPercentileTarget.value = '') : null
                " [disabled]="isPercentileTargetDisabled(base)" />
            </td>
            <td>{{ base.totalCooperation | customNumberFormat }}</td>
            <td>
              {{
              base.netTotalSimulation === 0 ? '-' : (base.netTotalSimulation | customNumberFormat)
              }}
            </td>
          </tr>
          }
        </tbody>
        <tfoot>
          <tr>
            <td><strong>Total simulé</strong></td>
            <td>{{ getSimulatedTotalQuantity() | customNumberFormat }}</td>
            <td>{{ getSimulatedTotalGrossAmountExclTax() | customNumberFormat }}&nbsp;€</td>
            <td>{{ getSimulatedTotalDiscountableEuroExclTax() | customNumberFormat }}&nbsp;€</td>
            <td>{{ getSimulatedTotalDiscountPercent() | customNumberFormat }}</td>
            <td>{{ getSimulatedTotalNetAmountExclTax() | customNumberFormat }}&nbsp;€</td>
            <td>{{ getSimulatedIndividualPercent() | customNumberFormat }}</td>
            <td>{{ globalTotalCooperation | customNumberFormat }}&nbsp;€</td>
            <td>{{ globalNetTotalSimulation | customNumberFormat }}&nbsp;€</td>
          </tr>
          <tr>
            <td><span>Total</span></td>
            <td>{{ getTotalQuantity() | customNumberFormat }}</td>
            <td>{{ getTotalGrossAmountExclTax() | customNumberFormat }}&nbsp;€</td>
            <td>{{ getTotalDiscountableEurExclTax() | customNumberFormat }}&nbsp;€</td>
            <td>
              <input type="text" id="totalPercentage" value="-" disabled />
            </td>
            <td>{{ getTotalNetAmountExclTax() | customNumberFormat }}&nbsp;€</td>
            <td>
              <input type="text" id="discountableTotal" value="-" disabled />
            </td>
            <td>-</td>
            <td>-</td>
          </tr>
        </tfoot>
      </table>
      <div class="horizontal-spacer"></div>
      <div class="table-footer">
        <div>
          <label style="display:none">Montant total brut remisable</label>
          <input style="display:none" matInput type="text" name="discountableTotal" id="discountableTotal"
            value="{{ getYearlyGrossTurnover() | customNumberFormat }}&nbsp;€" disabled />
        </div>
        <div>
          <label>Montant net HT des avoirs</label>
          <input matInput type="text" name="discountableTotal" id="discountableTotal"
            value="{{ getYearlyCreditAmountHT() | customNumberFormat }}&nbsp;€" disabled />
        </div>
        <div>
          <label>Ratio montant net HT avoirs/factures</label>
          <input matInput type="text" value="{{getCreditToInvoiceNetHTRatio() | customNumberFormat}}&nbsp;%" disabled />
        </div>

        <div>
          <label style="display:none">CA moyen brut mensuel</label>
          <input style="display:none" matInput type="text" name="averageMensualRevenue" id="averageMensualRevenue"
            value="{{ getAverageDiscountableGrossTurnover() | customNumberFormat }}&nbsp;€" disabled />
        </div>

        <div>
          <label>
            <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipTotalPercu" [matTooltipPosition]="TooltipPosition.ABOVE">
              Total perçu
            </span>
          </label>
          <input #inputAmountCollected matInput type="text" name="totalReceived"
            class="{{ modifiedAmountCollected() ? 'modified' : '' }}"
            value="{{ amountCollected | customNumberFormat }}&nbsp;€"
            (keyup.enter)="inputAmountCollected.blur(); focusNextInput($event)" (blur)="onAmountCollectedBlur($event)"
            (focus)="inputAmountCollected.value = ''" />
        </div>

        <div>
          <label>
            <span [matTooltip]="TOOLTIP_MESSAGES.msgTooltipResteARecevoir" [matTooltipPosition]="TooltipPosition.ABOVE">
              Reste à recevoir
            </span>
          </label>
          <input #inputAmountToCollect matInput type="text" name="toCollect" id="toCollect"
            value="{{ amountToCollect | customNumberFormat }}&nbsp;€" disabled />
        </div>
      </div>
    </div>
  </div>
</div>